<template>
  <div class="game-points">
    <loading-state :state="state"></loading-state>
    <div class="game-points-content" v-if="state.isLoaded()">
      <div class="all-players inv card" v-if="points">
        <h2>Fantasy Scorecard</h2>
        <p>Last updated at <span>{{points.updated_at | relativeShortDateTime}}</span></p>
        <div class="filter">
          <button
            class="clean small"
            v-for="filter in filters"
            :key="filter.uid"
            :class="[filter.kind, (activeFilter.uid == filter.uid)? 'active': '']"
            :style="{color: filter.color}"
            @click="activeFilter=filter"
            >{{filter.name}}</button>
        </div>
        <div class="player-items">
          <table>
            <tbody>
              <tr
              class="item"
              v-for="playerKey in playersToShow"
              :key="playerKey">
                <td
                  class="points for-name"
                >{{points.players[playerKey].points}}</td>
                <td class="name"
                  :style="{color: pointsColors[points.players[playerKey].points]}"
                >{{points.players[playerKey].player.jersey_name}}</td>
                <td class="team" :style="{xcolor: teamColors[points.players[playerKey].team.key]}"
                >{{points.players[playerKey].team.code}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { GamePoints } from '@/models/fantasygame/core'
import * as Colors from '@/models/fantasygame/colors'

class FilterableItem {
  constructor (kind, name, key, color) {
    this.uid = `${kind}|${key}`
    this.kind = kind
    this.name = name
    this.key = key
    this.color = color
  }
}

export default {
  props: {
    gameKey: String
  },
  data () {
    return {
      state: DataState.newLoading(),
      points: null,
      teamColors: {},
      roleColors: {},
      pointsColors: {},
      activeFilter: null,
      filters: []
    }
  },
  mounted () {
    this.onViewOpenned()
  },

  computed: {
    playersToShow () {
      if (!this.activeFilter || this.activeFilter.kind === 'all') {
        return this.points.player_keys
      }

      const filteredPlayers = []

      if (this.activeFilter.kind === 'team') {
        this.points.player_keys.forEach((key) => {
          if (this.points.players[key].team.key === this.activeFilter.key) {
            filteredPlayers.push(key)
          }
        })
      }

      if (this.activeFilter.kind === 'role') {
        this.points.player_keys.forEach((key) => {
          if (this.points.players[key].primary_role === this.activeFilter.key) {
            filteredPlayers.push(key)
          }
        })
      }

      return filteredPlayers
    }
  },

  methods: {
    onViewOpenned () {
      GamePoints.fetch(this.gameKey).then((resp) => {
        this.points = resp
        this.dataReady()
        this.state.changeToLoaded()
      }).catch((error) => {
        console.error(error)
        this.state.changeToError(error)
      })
    },

    dataReady () {
      const pointsColorsScale = ['orange', '#33a433']
      // const pointsColorsScale = ['black', '#1f5460']
      const roleColorsScale = [
        '#ec4bad', '#995eee', '#269191'
      ]
      this.teamColors = Colors.colorsFromList(this.points.team_keys)
      this.roleColors = Colors.colorsFromObjectProp('primary_role', this.points.players, roleColorsScale)
      this.pointsColors = Colors.colorsFromObjectProp('points', this.points.players, pointsColorsScale)

      const allFilter = new FilterableItem('all', 'Everyone', 'all', '')
      this.filters = [
        allFilter
      ]
      this.activeFilter = allFilter

      Object.keys(this.teamColors).forEach((key) => {
        const color = this.teamColors[key]
        const name = this.points.teams[key].code
        this.filters.push(
          new FilterableItem('team', name, key, color)
        )
      })

      Object.keys(this.roleColors).forEach((key) => {
        const color = this.roleColors[key]
        const name = key
        this.filters.push(
          new FilterableItem('role', name, key, color)
        )
      })

      // this.simulate()
    }

  }
}
</script>
